/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dark_Antsy_Bulldog_GrinInputs */

const en_dark_antsy_bulldog_grin = /** @type {(inputs: Dark_Antsy_Bulldog_GrinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select attribute...`)
};

const de_dark_antsy_bulldog_grin = /** @type {(inputs: Dark_Antsy_Bulldog_GrinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkmal auswählen...`)
};

/**
* | output |
* | --- |
* | "Select attribute..." |
*
* @param {Dark_Antsy_Bulldog_GrinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dark_antsy_bulldog_grin = /** @type {((inputs?: Dark_Antsy_Bulldog_GrinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dark_Antsy_Bulldog_GrinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dark_antsy_bulldog_grin(inputs)
	return de_dark_antsy_bulldog_grin(inputs)
});